module.exports = __webpack_public_path__ + "616bda2e65f2b5431349a5420509b337.jpg";